import axios from "axios";
import {
  getProfileRoute,
  imageUploadRoute,
  updateProfileRoute,
} from "../common/endpoints";

export const imageUploadfunc = async (file) => {
  try {
    var response = await axios
      .post(imageUploadRoute, file, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .catch(function () {
        console.log("FAILURE!!");
      });
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getUserProfile = async (cookies) => {
  const { userID, token } = cookies;
  const config = {
    method: "get",
    url: `${getProfileRoute}?userID=${userID}`,
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const updateUserProfile = async (cookies, updatedData) => {
  const { userID, token } = cookies;
  const config = {
    method: "put",
    url: `${updateProfileRoute}?userID=${userID}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(updatedData),
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
